export default "__VITE_ASSET__DA1PLCXj__"